(() => {
'use strict';
if(window.vanityFireworksReady)return;
window.vanityFireworksReady=true;
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let activeStop=null;
function play(duration){
if (reduced.matches) return;
if (activeStop) activeStop();
const canvas = document.createElement('canvas');
canvas.id = 'vanity-fireworks';
canvas.setAttribute('aria-hidden', 'true');
canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
document.body.append(canvas);
const ctx = canvas.getContext('2d');
if (!ctx) { canvas.remove(); return; }
let w, h, ratio, particles = [], frame, last = 0, start, expiry;
const resize = () => { w = innerWidth; h = innerHeight; ratio = Math.min(devicePixelRatio || 1, 2); canvas.width = w * ratio; canvas.height = h * ratio; ctx.setTransform(ratio, 0, 0, ratio, 0, 0); };
resize();
addEventListener('resize', resize, {passive:true});
const colors = ['255,211,112','255,232,173','230,178,75','255,247,223','224,232,246','255,255,255','190,204,224'];
const bursts = [
 {t:0,x:.15,y:.15},{t:70,x:.83,y:.2},{t:160,x:.5,y:.4},
 {t:280,x:.12,y:.65},{t:400,x:.86,y:.72},{t:510,x:.5,y:.88},
 {t:630,x:.45,y:.12},{t:740,x:.2,y:.42},{t:860,x:.78,y:.44},
 {t:980,x:.35,y:.7},{t:1080,x:.65,y:.6},{t:1200,x:.5,y:.32}
];
function burst(b) {
 const count = w < 750 ? 85 : 125;
 for(let i=0;i<count;i++){
  const angle=Math.random()*Math.PI*2, z=Math.random()*2-1;
  const ring=Math.sqrt(1-z*z), speed=Math.max(w,h)*(.25+Math.random()*.32);
  particles.push({x:0,y:0,z:0,ox:b.x*w,oy:b.y*h,vx:Math.cos(angle)*ring*speed,vy:Math.sin(angle)*ring*speed,vz:z*125,age:0,life:1.7+Math.random()*.9,color:colors[i%colors.length],size:.35+Math.random()*.55,trail:[]});
 }
}
function stop(){if(activeStop===stop)activeStop=null;clearTimeout(expiry);cancelAnimationFrame(frame);removeEventListener('resize',resize);document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',stop);canvas.remove();particles=[];}
function visibility(){if(document.hidden)stop();}
document.addEventListener('visibilitychange',visibility);
reduced.addEventListener('change',stop);
function draw(now){
 if(start===undefined)start=now;
 const elapsed=now-start, dt=Math.min((now-(last||now))/1000,.035);last=now;
 ctx.clearRect(0,0,w,h);
 for(const b of bursts)if(!b.done && elapsed>=b.t){b.done=true;burst(b);}
 ctx.globalCompositeOperation='source-over';
 particles=particles.filter(p=>p.age<p.life);
 for(const p of particles){
  p.age+=dt;p.x+=p.vx*dt;p.y+=p.vy*dt;p.z+=p.vz*dt;p.vy+=24*dt;p.vx*=Math.pow(.8,dt);p.vz*=Math.pow(.8,dt);
  const depth=480/(480-p.z),x=p.ox+p.x*depth,y=p.oy+p.y*depth;
  const fade=Math.min(1,Math.max(0,(duration-elapsed)/700));
  const alpha=Math.pow(1-p.age/p.life,.85)*fade,r=p.size*depth;
  p.trail.push({x,y});if(p.trail.length>7)p.trail.shift();
  ctx.beginPath();p.trail.forEach((v,i)=>i?ctx.lineTo(v.x,v.y):ctx.moveTo(v.x,v.y));
  const reflection=.72+.28*Math.sin(p.age*19+p.vx);
  ctx.strokeStyle='rgba('+p.color+','+(alpha*reflection*.95)+')';ctx.lineWidth=Math.max(.35,r*.7);ctx.stroke();
  if(p.trail.length>1){
   const prev=p.trail[p.trail.length-2],dx=x-prev.x,dy=y-prev.y,len=Math.hypot(dx,dy)||1;
   const shine=(1+Math.sin(p.age*23+p.vy))*.5;
   ctx.beginPath();ctx.moveTo(x-dx/len*(2+depth*2),y-dy/len*(2+depth*2));ctx.lineTo(x,y);
   ctx.strokeStyle='rgba(255,252,235,'+(alpha*(.45+shine*.55))+')';
   ctx.lineWidth=Math.max(.35,r*.45);ctx.stroke();
  }

 }
 if(elapsed>duration){stop();return;}
 frame=requestAnimationFrame(draw);
}
activeStop=stop;
expiry=setTimeout(stop,duration);
frame=requestAnimationFrame(draw);

}
const pendingKey='vanity-community-fireworks-pending';
document.addEventListener('submit',event=>{
 const form=event.target;
 if(!(form instanceof HTMLFormElement) || form.querySelector('input[name="form_type"]')?.value!=='customer')return;
 try{sessionStorage.setItem(pendingKey,String(Date.now()));}catch(_){}
},true);
let celebrated=false;
function celebrate(){
 if(celebrated || !document.querySelector('[data-vanity-community-success]'))return false;
 let pending=false;
 try{const stamp=Number(sessionStorage.getItem(pendingKey));pending=stamp>0 && Date.now()-stamp<600000;if(pending)sessionStorage.removeItem(pendingKey);}catch(_){pending=true;}
 if(!pending)return false;
 celebrated=true;
 play(4000);
 return true;
}
const observer=new MutationObserver(()=>{if(celebrate())observer.disconnect();});
observer.observe(document.body,{childList:true,subtree:true});
if(!celebrate()){
 let opened=false;
 try{opened=Boolean(sessionStorage.getItem('vanity-opening-fireworks-v4') || sessionStorage.getItem('vanity-opening-fireworks-v2'));sessionStorage.setItem('vanity-opening-fireworks-v4','1');}catch(_){}
 if(!opened)play(5000);
}
addEventListener('pagehide',()=>{if(activeStop)activeStop();observer.disconnect();},{once:true});
})();